<template>
  <div>
    <LoadingPage v-if="loadingData"></LoadingPage>
    <v-container v-if="!loadingData" fluid>
      <v-row>
        <v-col
          v-for="journey in mungedJourneys"
          :key="journey.id"
          class="d-flex child-flex pa-0"
          :cols="12 / numberOfColumns"
        >
          <div @click="journeyClickHandler(journey)" :style="journeyCursor(journey)">
            <v-card outlined color="grey">
              <v-responsive :aspect-ratio="1" :min-height="thumbnailSize">
                <MediaComponent
                  v-if="journey.title_media"
                  :media="journey.title_media"
                  :slot-width="thumbnailSize"
                  :slot-height="thumbnailSize"
                  thumbnail
                ></MediaComponent>

                <v-sheet
                  class="text-caption white--text font-weight-bold pa-1"
                  style="position:absolute;margin-left:auto;margin-right:auto;left: 0;right: 0;bottom:0; text-align: start;z-index: 4;background-color:rgba(0, 0, 0, 0.7);"
                >
                  {{ journey.name }}
                  <VisitDates
                    :in-date="journey.start_date"
                    :out-date="journey.end_date"
                    :visit-duration="journey.duration"
                    color="white"
                    horizontal
                    no-transport
                  ></VisitDates>
                </v-sheet>

                <CountryNameWithFlag
                  v-for="(country_code, index) in journey.country_codes"
                  :key="country_code"
                  :country-name="country_code"
                  :country-iso-code="country_code"
                  show-country-flag
                  :show-country-name="false"
                  class="ma-1"
                  :style="flagStyle(index)"
                ></CountryNameWithFlag>
                <PersonAvatar
                  v-for="(person, index) in journey.persons"
                  :key="person.id"
                  :avatar-filename="person"
                  :avatar-height="avatarSize().toString()"
                  class="ma-1"
                  :style="avatarStyle(index)"
                ></PersonAvatar>
              </v-responsive>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import APIService from '@/apiservices/APIService.js'
import LoadingPage from '@/components/LoadingPage.vue'
import MediaComponent from '@/components/MediaComponent.vue'
import CountryNameWithFlag from '@/components/CountryNameWithFlag.vue'
import PersonAvatar from '@/components/PersonAvatar.vue'
import VisitDates from '@/components/VisitDates.vue'
import { vueWindowSizeMixin } from 'vue-window-size'
export default {
  components: {
    MediaComponent,
    LoadingPage,
    CountryNameWithFlag,
    PersonAvatar,
    VisitDates
  },
  props: {
    year: {
      type: Number,
      required: true
    }
  },
  mixins: [vueWindowSizeMixin],
  computed: {
    numberOfColumns() {
      if (this.windowWidth > 600) {
        return 3
      } else {
        return 2
      }
    },
    thumbnailSize() {
      return this.windowWidth > 900
        ? 900 / this.numberOfColumns - 1
        : Math.round(this.windowWidth / this.numberOfColumns) - 1
    },
    mungedJourneys() {
      return this.journeys.map(v => {
        return {
          ...v,
          persons: [
            ...new Set(
              [].concat
                .apply(
                  [],
                  v.trips.map(p => p.persons)
                )
                .map(x => x.avatar_filename)
            )
          ],
          country_codes: [...new Set(v.trips.map(x => x.country_code))]
        }
      })
    }
  },
  data() {
    return {
      journeys: [],
      loadingData: false
    }
  },
  watch: {
    year: function(newVal) {
      console.log('NEW YEAR:', newVal)
      this.loadingData = true
      APIService.getJourneyPreviews({ journey_year: newVal })
        .then(({ data }) => {
          this.journeys = data
          this.loadingData = false
          console.log(this.mungedJourneys)
        })
        .catch(error => {
          console.log(
            'There was an error in getJourneyPreviews API call:',
            error
          )
        })
    }
  },
  created() {},
  methods: {
    journeyCursor(journey) {
      if (journey.count_articles > 0) {
        return 'cursor: pointer'
      } else {
        return ''
      }
    },
    journeyClickHandler(journey) {
      if (journey.count_articles > 0) {
        this.$emit('gotopage', journey)
      }
    },
    flagStyle(index) {
      let numberOfFlagsInCol = ~~(this.thumbnailSize / 20) - 3

      let row = index % numberOfFlagsInCol
      let col = ~~(index / numberOfFlagsInCol)
      let style =
        'position:absolute;margin-left:auto;margin-right:auto;right:' +
        col * 20 +
        'px;top:' +
        row * 20 +
        'px; text-align: start;z-index: 4;'

      return style
    },
    avatarSize() {
      if (this.thumbnailSize > 250) {
        return 35
      } else {
        return 30
      }
    },
    avatarStyle(index) {
      let numberOfAvatarsInCol = ~~(this.thumbnailSize / this.avatarSize()) - 2
      console.log(
        this.thumbnailSize,
        this.avatarSize(),
        ~~(this.thumbnailSize / this.avatarSize())
      )
      let row = index % numberOfAvatarsInCol
      let col = ~~(index / numberOfAvatarsInCol)
      let style =
        'position:absolute;margin-left:auto;margin-right:auto;left:' +
        col * (this.avatarSize() + 2) +
        'px;top:' +
        row * (this.avatarSize() + 2) +
        'px; text-align: start;z-index: 4;background-color:rgba(255, 255, 255, 0.9);'

      return style
    }
  }
}
</script>

<style></style>
